
const extract = (comment) => ({ author: comment.author, creationTime: comment.creationTime, text: comment.text })

const findById = (id, comments) => {
  if (comments && comments.length > 0) {
    for (let i = 0; i < comments.length; i++) {
      if (comments[i].id === id) { return comments[i] }
      const child = findById(id, comments[i].answers)
      if (child) { return child }
    }
  }
  return null
}

const findNewerComment = (current, answers) => {
  if (answers && answers.length > 0) {
    let latest = current
    for (let i = 0; i < answers.length; i++) {
      if (latest.creationTime < answers[i].creationTime) { latest = answers[i] }
      latest = findNewerComment(latest, answers[i].answers)
    }
    return latest
  }
  return current
}

export const prepareLastComments = (task) => {
  if (task && task.comments && task.comments.length > 0) {
    let latest = findNewerComment(task.comments[0], task.comments)
    if (latest.parentId) {
      const parent = findById(latest.parentId, task.comments)
      return { isEmpty: false, ...extract(parent), answer: extract(latest) }
    }

    return { isEmpty: false, ...extract(latest) }
  }
  return { isEmpty: true }
}



// WEBPACK FOOTER //
// ./src/internal-app/components/comments/TopBarComments.DataSource.js